import styled from 'styled-components'

import { semanticColors } from '../../styles/colors'
import { _2XS_Bold } from '../../styles/typography'

export const BetaFlag = styled.div`
  display: flex;
  color: white;
  ${_2XS_Bold};
  padding: 0 4px;
  align-items: center;
  background: ${semanticColors.failureMedium};
  margin-left: 6px;
  border-radius: 2px;
  height: 18px;
  line-height: 100%;
`
